document.addEventListener("DOMContentLoaded", function () {
  const isWideScreen = window.matchMedia("(min-width: 1024px)").matches;
  const sliderEl = document.querySelector(".header-slider");
  if (!sliderEl) return;

  const slides = Array.from(sliderEl.querySelectorAll(".swiper-wrapper > .swiper-slide"));
  let initialSlide = slides.findIndex((s) => s.dataset.initialSlide === "true");
  if (initialSlide < 0) initialSlide = 0;

  const swiper = new Swiper(".header-slider", {
    loop: true,
    initialSlide,
    effect: isWideScreen ? "fade" : "slide",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        effect: "fade",
      },
    },
    on: {
      init(sw) {
        sw.slideToLoop(initialSlide, 0, false);
      },
    },
  });
});
